import { FullAudit, IsActiveFlag } from '@/types';

export interface ConnectFlowCustomModel extends IsActiveFlag, FullAudit {
    id: number;
    levelId: number;
    name: string;
    flowIdentificator: string;
}
